import { render, staticRenderFns } from "./zhongrenyingtai.vue?vue&type=template&id=3c7ea980&scoped=true&"
import script from "./zhongrenyingtai.vue?vue&type=script&lang=js&"
export * from "./zhongrenyingtai.vue?vue&type=script&lang=js&"
import style0 from "./zhongrenyingtai.vue?vue&type=style&index=0&id=3c7ea980&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c7ea980",
  null
  
)

export default component.exports